<template>
    <div class="contact-custom-attributes">
        <template v-if="!hasCustomAttributes">
            <div class="contact-view__no-data">Contact has no custom attributes</div>
        </template>
        <template v-else>
            <contact-custom-attribute
                v-for="ca in state.customAttributes" :key="ca.id" :attribute="ca">
                data-test="contact-custom-attribute"
            </contact-custom-attribute>
        </template>
    </div>
</template>

<script setup>
import {computed, reactive} from 'vue';
import ContactCustomAttribute from './ContactCustomAttribute.vue';
import {contactsClient} from '../../../services';

const props = defineProps({
    contact: {
        type: Object,
        required: true,
    },
});

const state = reactive({
    customAttributes: [],
});

const fetchCustomAttributes = () => {
    contactsClient.contactCustomAttributesList(Spark.state.currentTeam.id, props.contact.id).then(response => {
        state.customAttributes = response.data.data;
    })
};

fetchCustomAttributes();

const hasCustomAttributes = computed(() => state.customAttributes.length > 0);
</script>

<style lang="scss">
.contact-custom-attributes {
    display: flex;
    flex-direction: column;
}
</style>
